// 在线等级分布数据/data/account_online_level
import request from '@/utils/request';
export function onlineLevel(data) {
  return request({
    url: '/data/account_online_level',
    method: 'get',
    params: data
  });
}